import React from 'react';
import { LatLng, MapLayer, MapLayerProps } from 'react-leaflet';
import L, { Layer } from 'leaflet';
import { withLeaflet } from 'react-leaflet';
import 'leaflet-routing-machine/src';
import 'leaflet-routing-machine/dist/leaflet-routing-machine.css';
import _ from 'lodash';

let _control;

interface RoutingMachineProps extends MapLayerProps {
  road: LatLng[];
  map: React.Ref<L.Map>;
  onDistanceFound?: (distanceInMeters: number) => any;
  onDurationFound?: (durationInSeconds: number) => any;
}

class RoutingMachine extends MapLayer<RoutingMachineProps> {
  private _control;

  componentDidUpdate(prevProps: Readonly<RoutingMachineProps>) {
    if (!_.isEqual(prevProps.road, this.props.road)) {
      _control.getPlan().setWaypoints(this.props.road);
    }

    super.updateLeafletElement(prevProps, this.props);
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    _control = undefined;
  }

  createLeafletElement() {
    // @ts-ignore
    const { color, map, road } = this.props;

    if (!_control?._map) {
      // @ts-ignore
      _control = L.Routing.control({
        waypoints: road,
        lineOptions: {
          styles: [
            {
              color,
              opacity: 0.8,
              weight: 6,
            },
          ],
        },
        addWaypoints: false,
        draggableWaypoints: false,
        fitSelectedRoutes: true,
        showAlternatives: false,
        altLineOptions: { styles: [{ opacity: 0 }] },
        createMarker: (i, wp, nWps) => {
          const marker = L.marker(wp.latLng, {
            keyboard: false,
          });

          if (i === 0 || i === 1) {
            marker.bindTooltip(i === 0 ? 'Salida' : 'Llegada', {
              permanent: true,
              direction: 'bottom',
            });
          } else {
            marker.bindTooltip('Disposición', {
              permanent: true,
              direction: 'bottom',
            });
          }

          return marker;
        },
      });

      _control.on('routesfound', (e) => {
        const routes = e.routes;
        const summary = routes[0].summary;
        // alert distance and time in km and minutes

        this.props.onDistanceFound?.(summary.totalDistance);
      });

      // @ts-ignore
      let leafletElement = _control.addTo(map?.current.leafletElement);

      leafletElement.hide(); // hide road describtion
      return leafletElement.getPlan();
    }

    _control.hide();
    return _control.getPlan();
  }
}

export default withLeaflet(RoutingMachine);
